export default function buildPostListingTagImage({
    apiEndpoint,
    apiTools
}) {
    return async function postListingTagImage(args) {
        const url = apiTools.resolveUrl({
            ...args,
            apiEndpoint: `${ apiEndpoint }/img` 
        })
       
        const res = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
            'Authorization': 'salaTokken'
            },
            credentials: 'include',
            body: args.body
        });
        return await res.json();
    }
}